var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Snackbar-warning",
    transform: "translate(-24.000000, -20.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(24.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01167793,11 C8.46132513,11 8,11.456 8,12 C8,12.544 8.46132513,13 9.01167793,13 C9.54179716,13 10.0233559,12.544 9.99907558,12.024 C10.0233559,11.452 9.56607743,11 9.01167793,11 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5619816,14.431302 C18.1429094,13.4562626 18.1466095,12.2941309 17.569382,11.3226895 L11.7749052,1.56510007 C11.2013778,0.582864853 10.1653283,0 9.00347277,0 C7.84161727,0 6.80556777,0.586462784 6.23204038,1.56150214 L0.430163224,11.3298853 C-0.14706435,12.3121205 -0.143364173,13.4814482 0.441263754,14.4564875 C1.01849133,15.4207331 2.05084064,16 3.20529579,16 L14.7794487,16 C15.937604,16 16.9773537,15.4135372 17.5619816,14.431302 Z M16.3039215,13.7261075 C15.9820061,14.2657972 15.4121789,14.586013 14.7757485,14.586013 L3.20159561,14.586013 C2.57256557,14.586013 2.00643852,14.272993 1.6919235,13.7440971 C1.3737083,13.2080054 1.37000812,12.5675736 1.68822332,12.027884 L7.49010047,2.26309872 C7.8046155,1.72700697 8.36704236,1.41038903 9.00347277,1.41038903 C9.63620299,1.41038903 10.20233,1.7306049 10.5168451,2.26669665 L16.315022,12.0314819 C16.6258369,12.5567799 16.6221367,13.1900157 16.3039215,13.7261075 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76435644,5.02661588 C8.29306931,5.15483246 8,5.56210865 8,6.05611958 C8.02376238,6.35403457 8.04356436,6.65572064 8.06732673,6.95363563 C8.13465347,8.08872946 8.2019802,9.20119683 8.26930693,10.3362907 C8.29306931,10.7209404 8.60594059,11 9.00990099,11 C9.41386139,11 9.73069307,10.702085 9.75049505,10.3136642 C9.75049505,10.0798575 9.75049505,9.86490617 9.77425743,9.6273284 C9.81782178,8.89951076 9.86534653,8.17169312 9.90891089,7.44387549 C9.93267327,6.97249101 9.97623762,6.50110653 10,6.02972205 C10,5.86002364 9.97623762,5.7091806 9.90891089,5.55833757 C9.70693069,5.13597708 9.23564356,4.92102575 8.76435644,5.02661588 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.01869c305005dc7f1d4927dd63d3271d.svg";
export { ForwardRef as ReactComponent };